import React from 'react'
import Modal from 'react-modal'
import { nl2br, formatBytes, formatName } from '../../modules/formatting'
import Lightbox from 'react-image-lightbox'
import moment from 'moment'
import PdfViewer from '../PdfViewer'

const modalStyle = {
  content : {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    width: '100%',
    height: '100%',
    padding: '0',
  }
}

class RequestInformationTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      photoIndex: 0,
      openLightBox: false,
      pdfIndex: 0,
      openPdfViewer: false,
    }
  }

  getChoiceName(id, choices, other = null) {
    // choicesからidの選択肢名を取り出し、その他が選択されていればotherを入れる
    if(!choices) return
    if(Array.isArray(id)) {
      const answers = id.map( key => {
        let answer = choices.filter( choice => choice.id === key)[0] || key
        return answer
      })
      let value = answers.length >= 1 ? answers.map( (answer, key) => (
        <div key={key} className="list-item">
          {answer.id === 'other' ? other : answer.name}
        </div>
      )) : null
      return value
    } else {
      const answer = choices.filter( answer => answer.id === id)[0]
      if(!answer) return id
      if(id === 'other' && other) {
        return other
      }
      return answer.name
    }
  }
  getPrefectureName(prefectureIDs) {
    let prefectures = '全国'
    if(prefectureIDs.length > 0) {
      const selectedPrefectures = this.props.prefectures.filter(
        pre => prefectureIDs.indexOf(String(pre.id)) !== -1
      )
      prefectures = <div>
        {selectedPrefectures.map((prefecture, key) => {
          return <span key={key}>{prefecture.name}</span>
        })}
      </div>
    }
    return prefectures
  }

  getContents() {
    let {
      title,
      choices,
      diseases,
      diseaseName,
      diseaseNameOther,
      birthYear,
      consultationOption,
      consultationOptionOther,
      answer1Description,
      answer2Description,
      answer3Description,
      answer4Description,
      cancerType,
      cancerTypes,
      cancerStep,
      cancerStepOther,
      otherDiseaseNames,
      otherDiseaseNamesOther,
      hospitalName,
      wantTransfer,
      offerArea,
      expirationDate,
      documentState,
      otherDocumentState,
      submissionMethod,
      contentConsultation,
      campaign,
      supportExtra
    } = this.props

    let postalAddress = (
      <React.Fragment>
        郵送<br/>
        <div className="signup-content__selected-post__address">
          &#12306;151-0051<br/>
          東京都渋谷区千駄ヶ谷5-21-12<br />
          S-FRONT代々木 7F<br/>
          Hatch Healthcare株式会社 Findme事務局 No.{this.props.findmeId} 宛<br/>
          TEL：{this.props.freecall}
        </div>
      </React.Fragment>
    )
    let serviceName = formatName('findme', campaign)
    let content = []
    if(choices.length === 0) {
      return content
    }
    if (campaign === 'FWD') {
      content = [
        {
          name: '相談タイトル',
          value: title,
        }, {
          name: '相談の病名',
          value: this.getChoiceName(diseaseName, diseases, diseaseNameOther),
        }, {
          name: '誕生年',
          value: birthYear ? `${birthYear}年` : null,
        }, {
          name: '相談したいこと',
          value: this.getChoiceName(consultationOption, choices.consultationOptions, consultationOptionOther),
        }, {
          name: '再発・転移',
          value: this.getChoiceName(cancerType, cancerTypes),
        }, {
          name: 'がんのステージ',
          value: this.getChoiceName(cancerStep, choices.cancerSteps, cancerStepOther)
        }, {
          name: '他の病名',
          value: this.getChoiceName(otherDiseaseNames, choices.otherDiseaseNamesList, otherDiseaseNamesOther)
        }, {
          name: '通院中の病院',
          value: hospitalName,
        }, {
          name: '転院の希望',
          value: this.getChoiceName(wantTransfer, choices.yesOrNo),
        }, {
          name: '希望地域',
          value: wantTransfer === 'yes' ? this.getPrefectureName(offerArea) : '',
        }, {
          name: '立候補の募集期限',
          value: moment(expirationDate).format('YYYY年MM月DD日'),
        }, {
          name: '紹介状',
          value: this.getChoiceName(documentState, choices.documentStates),
        }, {
          name: '他の書類',
          value: this.getChoiceName(otherDocumentState, choices.otherDocumentStates),
        }, {
          name: '資料の提供方法',
          value: submissionMethod === 'post' ? postalAddress : null,
        }, {
          name: '相談内容',
          value: nl2br(contentConsultation),
        }, {
          name: `${serviceName}事務局からの補足`,
          value: nl2br(supportExtra),
        }
      ]
    } else {
      content = [
        {
          name: '相談タイトル',
          value: title,
        }, {
          name: '相談の病名',
          value: this.getChoiceName(diseaseName, diseases, diseaseNameOther),
        }, {
          name: '誕生年',
          value: birthYear ? `${birthYear}年` : null,
        }, {
          name: '相談したいこと',
          value: this.getChoiceName(consultationOption, choices.consultationDetails, consultationOptionOther),
        }, {
          name: `「${choices.consultationDetails[0].name}」の詳細`,
          value: nl2br(answer1Description),
        }, {
          name: `「${choices.consultationDetails[1].name}」の詳細`,
          value: nl2br(answer2Description),
        }, {
          name: `「${choices.consultationDetails[2].name}」の詳細`,
          value: nl2br(answer3Description),
        }, {
          name: `「${choices.consultationDetails[3].name}」の詳細`,
          value: nl2br(answer4Description),
        }, {
          name: 'がんの初発か再発',
          value: this.getChoiceName(cancerType, cancerTypes),
        }, {
          name: 'がんのステージ',
          value: this.getChoiceName(cancerStep, choices.cancerSteps, cancerStepOther)
        }, {
          name: '他の病名',
          value: this.getChoiceName(otherDiseaseNames, choices.otherDiseaseNamesList, otherDiseaseNamesOther)
        }, {
          name: '通院中の病院',
          value: hospitalName,
        }, {
          name: '転院の希望',
          value: this.getChoiceName(wantTransfer, choices.yesOrNo),
        }, {
          name: '希望地域',
          value: wantTransfer === 'yes' ? this.getPrefectureName(offerArea) : '',
        }, {
          name: '立候補の募集期限',
          value: moment(expirationDate).format('YYYY年MM月DD日'),
        }, {
          name: '紹介状',
          value: this.getChoiceName(documentState, choices.documentStates),
        }, {
          name: '他の書類',
          value: this.getChoiceName(otherDocumentState, choices.otherDocumentStates),
        }, {
          name: '資料の提供方法',
          value: submissionMethod === 'post' ? postalAddress : null,
        }, {
          name: '相談内容',
          value: nl2br(contentConsultation),
        }, {
          name: `${serviceName}事務局からの補足`,
          value: nl2br(supportExtra),
        }
      ]
    }
    return content
  }

  getFiles(type) {
    return this.props.fileData.viewableFiles ?
      this.props.fileData.viewableFiles.filter(file => file.type === type) : []
  }
  render() {
    const props = this.props
    const contents = this.getContents()
    const {
      pdfIndex,
      photoIndex,
      openLightBox,
      openPdfViewer,
    } = this.state;

    let imgFiles = this.getFiles('image')
    let pdfFiles = this.getFiles('pdf')
    let selectedPdfData
    let selectedPdfName
    let documentFiles = props.fileData.documentFiles ? props.fileData.documentFiles : []
    let listImageLightBox = imgFiles.map((file) => (
      file.src
    ))
    let listImageTitle = imgFiles.map((file) => (
      file.cleaned ? file.cleaned_file_name : file.original_file_name
    ))
    if(openPdfViewer) {
      const pdf = pdfFiles[pdfIndex]
      selectedPdfData = pdf.src
      selectedPdfName = pdf.cleaned ? pdf.cleaned_file_name : pdf.original_file_name
    }
    const directoryUploads = Object.keys(props.directoryUploads).map((id) => props.directoryUploads[id])
    return (
      <React.Fragment>
        <div className="table-information-wrapper">
          <table className="table striped-find-me">
            <tbody>
              {contents.map((content) => content.value ? (
                <React.Fragment key={content.name}><tr>
                    <th scope="row">
                      {content.name}
                    </th>
                  </tr>
                  <tr>
                    <td>
                      {content.value}
                    </td>
                  </tr>
                </React.Fragment>
                ) : null
              )}
              <tr>
                <th scope="row">
                  アップロードファイル { props.files.length !== 0 &&
                    <span>（{props.files.length}件）</span>
                    }
                </th>
              </tr>
              <tr>
                <td className="files-wrapper">
                  { props.files.length === 0 && <span>なし</span> }
                  { imgFiles.map((file, key) =>
                      <div className="file" key={key} >
                        <span>
                          {file.cleaned ? file.cleaned_file_name : file.original_file_name}
                        </span>
                        <button onClick={() => this.setState({ openLightBox: true, photoIndex: key})}
                          className="btn-preview"
                          src={file.src}
                          id={file.id}
                          alt="プレビュー">プレビュー
                        </button>
                      </div>
                    )
                  }
                  { pdfFiles.map((file, key) =>
                      <div className="file" key={key} >
                        <span>
                          {file.cleaned ? file.cleaned_file_name : file.original_file_name}
                        </span>
                        <button onClick={() => this.setState({ openPdfViewer: true, pdfIndex: key})}
                          className="btn-preview"
                          src={file.src}
                          id={file.id}
                          alt="プレビュー">プレビュー
                        </button>
                      </div>
                    )
                  }
                  {documentFiles.map((file, key) =>
                    <div key={key} className="file">
                      <span>{file.original_file_name}</span>
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  CD/DVDの検査データ { props.directoryUploadsCount !== 0 &&
                    <span>（{props.directoryUploadsCount}件）</span>
                  }
                </th>
              </tr>
              <tr>
                <td className="files-wrapper">
                  { props.directoryUploadsCount === 0 && <span>なし</span> }
                  { directoryUploads.map((upload) => <div key={upload.id} className="file">
                    {upload.fileCount} 件のファイル ({formatBytes(upload.totalFileSize, 1)})
                  </div> )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Modal
          isOpen={openPdfViewer}
          onRequestClose={() => this.setState({ openPdfViewer: false })}
          ariaHideApp={false}
          style={modalStyle}
          >
          <PdfViewer
            file={selectedPdfData}
            name={selectedPdfName}
            onCloseRequest={() => this.setState({ openPdfViewer: false })}
          />
        </Modal>
        {openLightBox && (
          <Lightbox
            imageTitle={listImageTitle[photoIndex]}
            mainSrc={listImageLightBox[photoIndex]}
            nextSrc={listImageLightBox[(photoIndex + 1) % listImageLightBox.length]}
            prevSrc={listImageLightBox[(photoIndex + listImageLightBox.length - 1) % listImageLightBox.length]}
            onCloseRequest={() => this.setState({ openLightBox: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + listImageLightBox.length - 1) % listImageLightBox.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % listImageLightBox.length,
              })
            }
          />
        )}
    </React.Fragment>
    )
  }
}

export default RequestInformationTable



// WEBPACK FOOTER //
// ./src/components/RequestInformation/RequestInformationTable.js